export const AVATAR_COUNT = 154

export const AVATAR_PALETTE = [
    '#D8F6B3',
    '#FEFFB2',
    '#E3D4FF',
    '#B6A8D4',
    '#756B98',
    '#8A38F5',
    '#BAE0FF',
    '#FFE5B7',
    '#FFC65F',
    '#A98238',
    '#FFD0D0',
    '#FFA9BA',
    '#FF6D7D',
    '#B46C6C',
    '#C0C0C3',
    '#626266',
    '#211F28',
]

export const AVATAR_COLORS = [
    10, 0, 1, 0, 16, 15, 16, 8, 9, 7, 3, 4, 4, 4, 4, 7, 9, 10, 11, 12, 13, 13, 4, 3, 4, 9, 8, 8, 7, 7, 3, 5, 4, 5, 4,
    13, 10, 2, 3, 6, 11, 11, 11, 11, 11, 5, 4, 1, 1, 1, 13, 10, 3, 6, 6, 6, 6, 12, 12, 5, 4, 1, 1, 1, 12, 10, 9, 9, 6,
    6, 6, 6, 12, 12, 5, 5, 1, 1, 1, 13, 10, 8, 9, 6, 5, 4, 3, 3, 3, 3, 2, 5, 3, 0, 5, 5, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2,
    2, 2, 2, 2, 2, 2, 2, 0, 7, 8, 7, 8, 15, 14, 14, 14, 15, 0, 15, 2, 10, 14, 4, 7, 8, 6, 8, 11, 16, 13, 14, 0, 15, 16,
    1, 14, 16, 16, 15, 9, 16, 13, 3, 5, 7, 14, 15, 12,
]
